import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { MessageCircle, FileText, MapPin, ShieldCheck, Truck } from 'lucide-react';
import Header from './Header';

const Hero = () => {
  return (
    <section id="accueil" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Header */}
      <Header />

      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1588597989061-b60ad0eefdbf?w=1920&q=80"
          alt="Poulets de qualité"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-gold/20 backdrop-blur-sm border border-gold/30 rounded-full px-4 py-2 mb-6 animate-fade-in">
            <MapPin size={16} className="text-gold" />
            <span className="text-white text-sm font-medium">Production locale • Thiès, Sénégal</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight animate-fade-in-up">
            Poulets frais et congelés de qualité
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-200 mb-8 animate-fade-in-up animation-delay-200">
            Production locale • Hygiène maîtrisée • Livraison ou retrait
          </p>

          {/* Description */}
          <p className="text-lg text-gray-300 mb-10 max-w-2xl leading-relaxed animate-fade-in-up animation-delay-300">
            Volaille Prime vous propose des poulets soigneusement élevés, destinés aussi bien aux ménages qu'aux restaurants et revendeurs.
          </p>

          {/* Trust Indicators */}
          <div className="flex flex-wrap gap-6 mb-10 animate-fade-in-up animation-delay-400">
            <div className="flex items-center gap-2 text-white">
              <ShieldCheck size={20} className="text-gold" />
              <span className="text-sm">Hygiène certifiée</span>
            </div>
            <div className="flex items-center gap-2 text-white">
              <Truck size={20} className="text-gold" />
              <span className="text-sm">Livraison disponible</span>
            </div>
            <div className="flex items-center gap-2 text-white">
              <MapPin size={20} className="text-gold" />
              <span className="text-sm">Production locale</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-500">
            <a 
              href="https://wa.me/221781270846?text=Bonjour,%20je%20souhaite%20commander%20des%20poulets"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Button 
                size="lg" 
                className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white gap-2 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
              >
                <MessageCircle size={20} />
                Commander sur WhatsApp
              </Button>
            </a>
            <Link to="/produits" className="w-full sm:w-auto">
              <Button 
                size="lg" 
                variant="outline"
                className="w-full bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-white/30 gap-2 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
              >
                <FileText size={20} />
                Passer une commande en ligne
              </Button>
            </Link>
          </div>
          
          {/* Contact Numbers - Subtle display */}
          <div className="flex flex-wrap gap-4 mt-6 text-sm text-gray-200 animate-fade-in-up animation-delay-600">
            <a href="tel:+221781270846" className="hover:text-gold transition-colors">
              📞 +221 78 127 08 46
            </a>
            <span className="text-gray-400">|</span>
            <a href="tel:+221779093914" className="hover:text-gold transition-colors">
              📞 +221 77 909 39 14
            </a>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-cream to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
